import Badge from '../../ui/Badge';
import { SkeletonCard } from '../../ui/Skeleton';
import ServiceOrderCard from './ServiceOrderCard';
import { GroupServiceOrdersByColumn, SERVICE_ORDER_COLUMNS } from './serviceOrderModel';

/**
 * O QUADRO (§8.1.5): BACKLOG · READY · IN_PROGRESS · DONE.
 *
 * Colunas de altura igual e rolagem própria: a fila de decisão pode ter 3
 * cartões e a de concluídas 60, e uma coluna que estica a página inteira faz
 * as outras sumirem do campo de visão — o quadro deixa de ser quadro.
 *
 * `BACKLOG` e `READY` ganham a frase de ajuda do dicionário: são as duas
 * colunas cujo significado não é óbvio pelo nome ("Fila de decisão" é onde o
 * Supervisor decide; "Liberadas" é o que o coletor enxerga, e o primeiro que
 * aceitar leva).
 */
const COLUMN_HELP = {
    BACKLOG: 'wms.kanban.BACKLOG_help',
    READY: 'wms.kanban.READY_help',
};

const ServiceOrderBoard = ({
    orders,
    label,
    loading = false,
    canManage = false,
    includeCanceled = false,
    busyId = null,
    onOpen,
    onApprove,
    onDeny,
}) => {
    const grouped = GroupServiceOrdersByColumn(orders, { includeCanceled });

    return (
        <div className="grid gap-3 lg:grid-cols-4">
            {SERVICE_ORDER_COLUMNS.map((column) => {
                const rows = grouped[column];
                return (
                    <section
                        key={column}
                        className="flex min-h-[220px] flex-col rounded-xl border border-mono-200 bg-mono-50 dark:border-mono-800 dark:bg-mono-950"
                    >
                        <header className="space-y-1 border-b border-mono-200 p-3 dark:border-mono-800">
                            <div className="flex items-center justify-between gap-2">
                                <h2 className="text-sm font-semibold uppercase tracking-wide text-mono-700 dark:text-mono-300">
                                    {label(`wms.kanban.${column}`)}
                                </h2>
                                <Badge variant="neutral">{rows.length}</Badge>
                            </div>
                            {COLUMN_HELP[column] ? (
                                <p className="text-[11px] leading-snug text-mono-500 dark:text-mono-400">
                                    {label(COLUMN_HELP[column])}
                                </p>
                            ) : null}
                        </header>

                        <div className="flex max-h-[62vh] flex-col gap-2 overflow-y-auto p-2">
                            {loading ? (
                                <SkeletonCard />
                            ) : rows.length === 0 ? (
                                <p className="p-2 text-xs text-mono-500 dark:text-mono-400">
                                    {label('wms.service_orders.empty')}
                                </p>
                            ) : (
                                rows.map((order) => (
                                    <ServiceOrderCard
                                        key={order.id}
                                        order={order}
                                        label={label}
                                        canManage={canManage}
                                        busy={busyId === order.id}
                                        onOpen={onOpen}
                                        onApprove={onApprove}
                                        onDeny={onDeny}
                                    />
                                ))
                            )}
                        </div>
                    </section>
                );
            })}
        </div>
    );
};

export default ServiceOrderBoard;
